import { render, staticRenderFns } from "./content_detail.vue?vue&type=template&id=15e4c3bd&scoped=true&"
import script from "./content_detail.vue?vue&type=script&lang=js&"
export * from "./content_detail.vue?vue&type=script&lang=js&"
import style0 from "./content_detail.vue?vue&type=style&index=0&id=15e4c3bd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e4c3bd",
  null
  
)

export default component.exports